export default function resetError() {
	return { type: "RESET_ERROR" };
}
